import React from 'react';
import Icon from '../Icon';
import ProductImage from '../ProductImage';

export default function SellerOverview({
  seller,
  products,
  orders,
  loading,
  onNavigate,
}) {
  const variants = products.flatMap((p) => p.variants || []);
  const published = products.filter((p) =>
    p.variants?.some((v) => v.price > 0 && v.stock > 0)
  );
  const missingPrice = variants.filter((v) => !(v.price > 0)).length;
  const lowStock = variants.filter((v) => v.stock <= 5).length;
  const newOrders = orders.filter((o) => o.status === 'PAID').length;
  const stats = [
    {
      label: 'Товаров в продаже',
      value: published.length,
      detail: `из ${products.length} в ассортименте`,
      icon: 'box',
      tab: 'products',
    },
    {
      label: 'Ждут обработки',
      value: newOrders,
      detail: 'оплаченные заказы',
      icon: 'bag',
      tab: 'orders',
    },
    {
      label: 'Единиц на складе',
      value: variants.reduce((n, v) => n + v.stock, 0),
      detail: `${variants.length} вариантов SKU`,
      icon: 'layers',
      tab: 'stock',
    },
    {
      label: 'Мало остатков',
      value: lowStock,
      detail: 'варианты с остатком до 5 шт.',
      icon: 'alert',
      tab: 'stock',
    },
  ];
  const tasks = [
    {
      title: 'Обработать новые заказы',
      description: newOrders
        ? `${newOrders} оплаченных заказов ждут вашего действия`
        : 'Все оплаченные заказы взяты в работу',
      count: newOrders,
      tab: 'orders',
      icon: 'bag',
    },
    {
      title: 'Проверить остатки',
      description: lowStock
        ? `${lowStock} вариантов с небольшим или нулевым остатком`
        : 'Запасов достаточно для следующих заказов',
      count: lowStock,
      tab: 'stock',
      icon: 'layers',
    },
    {
      title: 'Заполнить цены',
      description: missingPrice
        ? `${missingPrice} вариантов пока не доступны к продаже`
        : 'У всех вариантов указана цена',
      count: missingPrice,
      tab: 'prices',
      icon: 'tag',
    },
  ];
  return (
    <div className="seller-overview">
      <div className="seller-page-heading">
        <div>
          <span className="eyebrow">ВАШ РАБОЧИЙ ДЕНЬ</span>
          <h1>
            Хороший день для продаж<span>.</span>
          </h1>
          <p>{seller.name}, вот что происходит в вашем магазине.</p>
        </div>
        <button
          className="btn btn-primary"
          onClick={() => onNavigate('products', { action: 'create' })}
        >
          <Icon name="plus" size={18} />
          Добавить товар
        </button>
      </div>
      <div className="seller-stat-grid">
        {stats.map((stat) => (
          <button
            key={stat.label}
            onClick={() => onNavigate(stat.tab)}
            className="seller-stat"
          >
            <span
              className={`seller-stat-icon ${stat.tab === 'stock' && stat.icon === 'alert' ? 'is-amber' : ''}`}
            >
              <Icon name={stat.icon} />
            </span>
            <span className="seller-stat-label">{stat.label}</span>
            <strong>
              {loading ? '—' : stat.value.toLocaleString('ru-RU')}
            </strong>
            <small>{loading ? 'Обновляем данные…' : stat.detail}</small>
          </button>
        ))}
      </div>
      <div className="seller-overview-columns">
        <section className="seller-panel seller-tasks">
          <div className="seller-panel-title">
            <h2>Требует внимания</h2>
            <span>На сегодня</span>
          </div>
          {tasks.map((task) => (
            <button
              key={task.tab}
              className="seller-task"
              onClick={() => onNavigate(task.tab)}
            >
              <span
                className={`seller-task-icon ${task.count ? 'needs-action' : ''}`}
              >
                <Icon name={task.count ? task.icon : 'check'} size={20} />
              </span>
              <span>
                <strong>{task.title}</strong>
                <small>{loading ? 'Проверяем…' : task.description}</small>
              </span>
              {!loading && task.count > 0 && <b>{task.count}</b>}
              <Icon name="chevron" size={18} />
            </button>
          ))}
        </section>
        <section className="seller-start-panel">
          <span className="eyebrow">ПРОСТОЙ ПОРЯДОК РАБОТЫ</span>
          <h2>
            От карточки <br />
            до первого заказа.
          </h2>
          <p>
            Добавьте фотографии, укажите цены и остатки. Доступные товары
            появятся на витрине.
          </p>
          <button onClick={() => onNavigate('products')}>
            Перейти к товарам <Icon name="arrow" size={18} />
          </button>
        </section>
      </div>
      <section className="seller-panel seller-recent">
        <div className="seller-panel-title">
          <div>
            <h2>Ваш ассортимент</h2>
            <p>Быстрый переход к карточкам и вариантам</p>
          </div>
          <button onClick={() => onNavigate('products')}>
            Все товары <Icon name="arrow" size={16} />
          </button>
        </div>
        {loading ? (
          <p className="seller-muted">Загружаем ассортимент…</p>
        ) : !products.length ? (
          <div className="market-empty">
            <Icon name="box" size={30} />
            <h3>Магазин начинается с первого товара</h3>
            <button
              className="btn btn-primary"
              onClick={() => onNavigate('products', { action: 'create' })}
            >
              Добавить товар
            </button>
          </div>
        ) : (
          <div className="seller-recent-grid">
            {products.slice(0, 4).map((p) => (
              <button
                key={p.id}
                onClick={() =>
                  onNavigate('products', { q: p.sellerSku || p.title })
                }
              >
                <ProductImage product={p} width={42} height={56}  />
                <span>
                  <strong>{p.title}</strong>
                  <small>
                    {p.variants?.length || 0} вариантов ·{' '}
                    {p.variants?.reduce((n, v) => n + v.stock, 0) || 0} шт.
                  </small>
                </span>
                <Icon name="chevron" size={16} />
              </button>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
